import React from 'react';
import classNames from 'classnames';
import { AddFileIcon } from '@/components/icons/AddFileIcon';

interface IEmptyStateProps {
    onAddWidget: () => void;
}

const EmptyState = ({ onAddWidget }: IEmptyStateProps) => {
    return (
        <div className={classNames('w-full', 'h-full', 'flex', 'items-center', 'justify-center')}>
            <div className={classNames('max-w-1/2', 'py-30', 'flex', 'flex-col', 'items-center', 'justify-center', 'gap-2')}>
                <div className={classNames('rounded-full', 'p-4', 'bg-slate-100')}>
                    <AddFileIcon size={32} />
                </div>
                <h1 className={classNames('text-2xl', 'font-medium', 'mb-2', 'text-center')}>Start Building Your Page</h1>
                <p className={classNames('text-center', 'text-gray-500')}>
                    Use the widget panel on the right to add widgets to your custom page. You can choose from various widget types including charts, tables, metrics, and more.
                </p>
            </div>
        </div>
    );
};



export { EmptyState }
